import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonDataTable from './commonTable';
import PostedJobDetails from '../OffCanvas/others/PostedJobDetails';
import { __jobStatusDisplay } from '../../constants';
import styled from '@emotion/styled';
import { formatWithTZ } from '../../utils';

const JobPosted = () => {
  const navigate = useNavigate();
  const [canvasState, setCanvasState] = React.useState({
    open: false,
    userId: "",
    applicationId: ""
  });

  const headers = [
    { label: "Status" },
    { label: "Job No" },
    { label: "Job description" },
    { label: "Posted by" },
    { label: "Posted for" },
    { label: "Applications", style: { textAlign: "center" } },
    { label: "Posted on" },
    { label: "Booked / Finalized on" }
  ];

  const handleClick = (id) => {
    navigate(`appliers?id=${id}`);
  };

  const renderRow = (item, statusClassMap) => {
    return (
      <>
        <li className="pointer" style={{ overflow: "hidden", display: "flex" }}>
          <span className={`list_card_status ${statusClassMap[item.jobStatus] || ""}`}>
            {__jobStatusDisplay[item.jobStatus] || "Unknown"}
          </span>
        </li>
        <li>{item.displayedJobId || "NA"}</li>
        <li>{item.jobDescription || "NA"}</li>
        <li 
          className="pointer" 
          onClick={() => { navigate("/users/seekers-listing?id=" + item.jobPostedBy._id) }}
        >
          {item.jobPostedBy.firstName} {item.jobPostedBy.lastName}
        </li>
        <li>{item.jobPostedFor}</li>
        <li 
          onClick={() => { handleClick(item._id) }} 
          className="pointer text-center"
        >
          {item.appliedJobs}
        </li>
        <li>{formatWithTZ(item.createdAt, "Do MMM, YYYY")}</li>
        <li>
          {item?.applicationInfo?.bookedOn
            ? formatWithTZ(item.applicationInfo.bookedOn, "Do MMM, YYYY")
            : "-"}{" "}
          /{" "}
          {item.completedOn
            ? formatWithTZ(item.completedOn, "Do MMM, YYYY")
            : "-"}
        </li>
      </>
    );
  };

  const handleRowClick = (item, setCanvasState) => {
    setCanvasState({
      open: true,
      jobId: item._id,
      applicationId: item._id
    });
  };

  return (
    <JobPostedWrapper>
      <CommonDataTable
        type="Job"
        profileNavTitle="Jobs"
        headers={headers}
        renderRow={renderRow}
        onRowClick={handleRowClick}
        canvasComponent={PostedJobDetails}
        canvasState={canvasState}
        setCanvasState={setCanvasState}
        additionalParams={{}}
        customGridColumns="1.6fr 1fr 2.5fr 2fr 1fr 1.5fr 1.2fr 1.2fr 0.5fr"
      />
    </JobPostedWrapper>
  );
};

// Additional styling specific to JobPosted
const JobPostedWrapper = styled.div`
  .list-header:hover {
    background: unset;
  }
`;

export default JobPosted;